import React from 'react';
import { Layout } from './Layout';
import { Login } from '../organisms/Login';
import { observer } from 'mobx-react-lite';

interface Props {
  match: any;
}

export const LoginPage = observer((props: Props) => {
  return (
    <Layout>
      <Login />
    </Layout>
  );
});
